export default __webpack_public_path__ + "static/media/topic900_bg1.37c7ec0b.png";